<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!-- 신규 -->
					<sf-button
						v-if="isButton_(scrId, 'CC') && (flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp || flgOsGrp)"
						line
						icon="file"
						:onClick="addAction"
					>
						{{ getMessage_('QWCC001083') }}
					</sf-button>
					<!-- 저장 -->
					<sf-button
						line
						icon="file"
						color="info"
						:onClick="tempSaveAction"
						v-if="isButton_(scrId, 'TS') && !resultMaster.pprrDd && (flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp || flgOsGrp)"
					>
						{{ getButtonMsg_(scrId, 'TS') }}
					</sf-button>
					<!-- 작성 -->
					<sf-button
						line
						icon="round-check-on"
						:onClick="saveAction"
						v-if="isButton_(scrId, 'WR') && !resultMaster.pprrDd && (flgPqyapGrp || flgPqyrvGrp || flgPqyrgGrp || flgOsGrp)"
					>
						{{ getButtonMsg_(scrId, 'WR') }}
					</sf-button>
					<!-- 삭제 -->
					<sf-button
						color="error"
						line
						v-if="isButton_(scrId, 'CD') && resultMaster.rgnDt && !resultMaster.pprrNm && resultMaster.rgnId == gsUserId"
						icon="trash"
						:onClick="deleteAction"
					>
						{{ getMessage_('MWCC000328') }}
					</sf-button>
					<!-- 이상통보 -->
					<sf-button
						line
						icon="error"
						:onClick="openReport"
						v-if="isButton_(scrId, 'AB') && resultMaster.ngPrvsCt && Number(resultMaster.ngPrvsCt) > 0 && resultMaster.pprrNm"
					>
						{{ getButtonMsg_(scrId, 'AB') }}
					</sf-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourRgst/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			flgPqyapGrp: false, //관리자(승인)
			flgPqyrvGrp: false, //중간관리자(검토)
			flgPqyrgGrp: false, //업무담당자(작성)
			flgOsGrp: false, //관리자
			gsUserId: '' //로그인ID
		};
	},
	async created() {
		this.getPqyap();
		this.getPqyrv();
		this.getPqyrg();
		this.getOs();
		this.getUserId();
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed,
		schemaSave() {
			return Yup.object().shape({
				newInsnDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001390')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001390')])) //{0}은(는) 팔수 입력 값 입니다. ,
			});
		},
		schemaReg() {
			return Yup.array().of(
				Yup.object().shape({
					insnRsltCd: Yup.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('RCMS000093')])) //{0}은(는) 팔수 입력 값 입니다. ,
				})
			);
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		getUserId() {
			this.gsUserId = window.atob(this.user.userId); //로그인ID
		},
		async getPqyap() {
			this.flgPqyapGrp = await this.inclUsrGrp_('PQYAP'); //생산품질 관리자(승인)
			//console.log('getPqyap >>> ', this.flgPqyapGrp);
		},
		async getPqyrv() {
			this.flgPqyrvGrp = await this.inclUsrGrp_('PQYRV'); //생산품질 중간관리자(검토)
			//console.log('getPqyrv >>> ', this.flgPqyrvGrp);
		},
		async getPqyrg() {
			this.flgPqyrgGrp = await this.inclUsrGrp_('PQYRG'); //생산품질 일반사용자(작성)
			//console.log('getPqyrg >>> ', this.flgPqyrgGrp);
		},
		async getOs() {
			this.flgOsGrp = await this.inclUsrGrp_('OS'); //관리자
			//console.log('flgOsGrp >>> ', this.flgOsGrp);
		},
		/**임시 저장 */
		openReport() {
			//console.log('this.resultMaster', this.resultMaster);
			this.$emit('openReport', this.resultMaster);
		},
		//신규 처리
		async addAction() {
			if (this.searchParams.powLnCd == '') {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001752') });
				return;
			} else {
				this.setSearchParam_({ key: 'powLnCd', value: this.searchParams.powLnCd });
				this.setSearchParam_({ key: 'insnDd', value: this.$moment().format('YYYYMMDD') });
				this.setSearchParam_({ key: 'ipnNos', value: '1000' });
				this.$emit('Refresh');
			}
		},
		async tempSaveAction() {
			try {
				//console.log('this.resultMaster.oldInsnDd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.oldInsnDd);
				//console.log('this.resultMaster.newInsnDd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.newInsnDd);
				//old검사일자 존재할 경우
				if (this.resultMaster.oldInsnDd !== '' && this.resultMaster.oldInsnDd !== null) {
					//저장된 데이터는 자동으로 그리드 체크박스를 선택하도록 한다.
					this.$emit('selectUnChecks');
					//this.$emit('selectChecks');
				}

				this.$emit('selectDetails');
				//console.log('this.resultMaster.powLnCd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.powLnCd);
				//console.log('this.searchParams.powLnCd >>>>>>>>>>>>>>>>>>>>>> ', this.searchParams.powLnCd);
				if (this.resultMaster.powLnCd !== this.searchParams.powLnCd) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001403') });
					this.setSearchParam_({ key: 'powLnCd', value: this.resultMaster.powLnCd });
					return;
				}

				//임시 저장일 떄
				await this.schemaSave.validateSync(this.resultMaster);
				//console.log('this.selectedRows.length >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', this.selectedRows.length);
				if (this.selectedRows.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('MWCC000110')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001119'),
					buttons: [{ title: 'Ok', clickFn: () => this.save('10') }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async saveAction() {
			try {
				//console.log('this.resultMaster.oldInsnDd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.oldInsnDd);
				//console.log('this.resultMaster.newInsnDd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.newInsnDd);
				//old검사일자 존재할 경우
				if (this.resultMaster.oldInsnDd !== '' && this.resultMaster.oldInsnDd !== null) {
					//저장된 데이터는 자동으로 그리드 체크박스를 선택하도록 한다.
					this.$emit('selectUnChecks');
					//this.$emit('selectChecks');
				}

				this.$emit('selectDetails');
				//console.log('this.resultMaster.powLnCd >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.powLnCd);
				//console.log('this.searchParams.powLnCd >>>>>>>>>>>>>>>>>>>>>> ', this.searchParams.powLnCd);
				if (this.resultMaster.powLnCd !== this.searchParams.powLnCd) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001403') });
					this.setSearchParam_({ key: 'powLnCd', value: this.resultMaster.powLnCd });
					return;
				}

				// 작성일 떄
				await this.schemaSave.validateSync(this.resultMaster);
				//console.log('this.selectedRows.length >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', this.selectedRows.length);
				if (this.selectedRows.length < 1) {
					this.$sf_showMessage({
						icon: 'error',
						title: this.getMessage_('MWCC000109'),
						message: this.getMessage_('MWCC000110')
					}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
					return;
				}

				await this.schemaReg.validateSync(this.selectedRows);

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001119'),
					buttons: [{ title: 'Ok', clickFn: () => this.save('20') }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async save(paramState) {
			this.$emit('selectDetails');

			//저장
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.resultMaster).forEach(key => {
				if (this.resultMaster[key] == 0 || !!this.resultMaster[key]) {
					formData.append(key, convertNvl(this.resultMaster[key], ''));
				}
				//console.log('convertNvl>>>>>>', convertNvl(this.resultMaster[key], ''));
			});

			//첨부파일 fileList로 바뀜
			//console.log('fileList >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.fileList);
			if (this.resultMaster.fileList.length > 0) {
				this.resultMaster.fileList.forEach(element => {
					formData.append('fileList', element);
					//console.log('element', element);
				});
			} else {
				//console.log('fileList 건수없음');
				formData.append('fileList', '');
			}

			//공정순회 상세리스트 셋팅
			if (this.selectedRows.length > 0) {
				this.selectedRows.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						if (element[key] == 0 || !!element[key]) {
							formData.append('partList[' + index + '].' + key, element[key]);
						}
						//console.log('key', element[key]);
					});
				});
			} else {
				formData.append('partList', '');
			}
			//paramState값은 10은 임시저장, 20번 작성
			formData.append('state', paramState);

			//fromData 찍어보기
			//let object = {};
			//formData.forEach((value, key) => (object[key] = value));
			//let json = JSON.stringify(object);

			//console.log('jsonData>>>>>>>>>>', json);

			//console.log('formData>>>>>>>>>>', formData);

			await this.setPowTourRgstManagement_({ formData })
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
						response.code === 0 && this.$emit('Refresh');
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error?.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		deleteAction() {
			try {
				//console.log('this.resultMaster.rgnDt >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.rgnDt);
				//등록일자가 존재하지 않을 경우
				if (this.resultMaster.rgnDt == '' && this.resultMaster.rgnDt == null) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001147') });
					return;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001196'),
					buttons: [{ title: 'Ok', clickFn: () => this.remove() }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async remove() {
			//삭제
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.resultMaster).forEach(key => {
				if (this.resultMaster[key] == 0 || !!this.resultMaster[key]) {
					formData.append(key, convertNvl(this.resultMaster[key], ''));
				}
				//console.log('convertNvl>>>>>>', convertNvl(this.resultMaster[key], ''));
			});

			//첨부파일 fileList로 바뀜
			//console.log('fileList >>>>>>>>>>>>>>>>>>>>>> ', this.resultMaster.fileList);
			if (this.resultMaster.fileList.length > 0) {
				this.resultMaster.fileList.forEach(element => {
					formData.append('fileList', element);
					//console.log('element', element);
				});
			} else {
				//console.log('fileList 건수없음');
				formData.append('fileList', '');
			}

			await this.setPowTourRgstDelete_({ formData })
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
						response.code === 0 && this.$emit('Refresh');
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error?.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style lang="scss" scoped></style>
